import { useEffect } from "react";
import "./ConfusionAnimation.css";

export default function ConfusionAnimation({ playerRef, opponentRef, onComplete }) {
  useEffect(() => {
    const playerEl = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl || !opponentEl) return;

    const container = playerEl.closest(".battle-container"); // grab outer container
    const bg = container?.querySelector(".battle-bg");       // target background inside

    const pRect = playerEl.getBoundingClientRect();
    const oRect = opponentEl.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();

    const startX = (pRect.left + pRect.width / 2) - cRect.left;
    const startY = (pRect.top + pRect.height / 2) - cRect.top;
    const endX = (oRect.left + oRect.width / 2) - cRect.left;
    const endY = (oRect.top + oRect.height / 2) - cRect.top;

    const dx = endX - startX;
    const dy = endY - startY;
    const angle = Math.atan2(dy, dx) + "rad";

    const pulseCount = Math.floor(Math.random() * 3) + 4; // 4–6 pulses
    const pulses = [];

    for (let i = 0; i < pulseCount; i++) {
      const ring = document.createElement("div");
      ring.className = "confusion-ring";
      ring.style.left = `${startX}px`;
      ring.style.top = `${startY}px`;
      ring.style.animationDelay = `${i * 0.1}s`;

      const spreadX = dx + (Math.random() - 0.5) * 30;
      const spreadY = dy + (Math.random() - 0.5) * 30;

      ring.style.setProperty("--dx", `${spreadX}px`);
      ring.style.setProperty("--dy", `${spreadY}px`);
      ring.style.setProperty("--angle", angle);

      container.appendChild(ring);
      pulses.push(ring);
    }

    const handleImpact = () => {
      pulses.forEach(p => p.remove());

      opponentEl.classList.add("confusion-hit");
      setTimeout(() => opponentEl.classList.remove("confusion-hit"), 300);

      // 🧠 Psychic background flicker (correctly targets battle-bg)
      if (bg) {
        bg.classList.add("flicker");
        setTimeout(() => bg.classList.remove("flicker"), 400);
      }

      // 💥 Ripple distortion
      const ripple = document.createElement("div");
      ripple.className = "confusion-ripple";
      ripple.style.left = `${endX}px`;
      ripple.style.top = `${endY}px`;
      container.appendChild(ripple);

      setTimeout(() => {
        ripple.remove();
        onComplete();
      }, 600);
    };

    const last = pulses[pulses.length - 1];
    last.addEventListener("animationend", handleImpact);

    return () => {
      last.removeEventListener("animationend", handleImpact);
      pulses.forEach(p => p.remove());
    };
  }, [playerRef, opponentRef, onComplete]);

  return null;
}

ConfusionAnimation.moveType = "psychic";
